import { Component } from "react";
/**
 * Without this, an uncaught render error anywhere in the tree unmounts
 * the whole app and leaves a blank white page — no message, no way back.
 * This catches it, shows something a user can act on, and resets on
 * navigation rather than trapping them.
 */
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("Unhandled UI error:", error, info.componentStack);
    }
    render() {
        if (this.state.error) {
            return (<div style={{
                    minHeight: "50vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                    background: "var(--paper)",
                    padding: 24,
                    textAlign: "center",
                }}>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: "1.3rem", color: "var(--ink)" }}>
            Something went wrong
          </div>
          <div style={{ color: "var(--ink-soft)", fontSize: "0.88rem", maxWidth: 420 }}>
            This screen hit an unexpected error. Your data is safe — try reloading, and if it keeps happening, let the
            team know what you were doing.
          </div>
          <button onClick={() => {
                    this.setState({ error: null });
                    window.location.href = "/legal-cases";
                }} style={{
                    marginTop: 8,
                    background: "var(--brand)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    padding: "9px 18px",
                    borderRadius: 8,
                    border: "none",
                    cursor: "pointer",
                }}>
            Back to Dashboard
          </button>
        </div>);
        }
        return this.props.children;
    }
}
